function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import _LinearProgress2 from "@mui/material/LinearProgress";
import _ButtonBase from "@mui/material/ButtonBase";
var _ArrowRight, _LinearProgress;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { array, arrayOf, bool, func, number, object, oneOf, shape, string } from 'prop-types';
import clsx from 'clsx';
import { decomposeColor, recomposeColor, emphasize, styled } from '@mui/material/styles';
import { ArrowRight } from 'mosaic-react-icons';
import SovosTypography from '../../sovos-typography';
import SovosCheckbox from '../../sovos-checkbox';
import SectionDivider from './SectionDivider';
import SovosIconButton from '../../sovos-icon-button';
import SovosFixedWidthText from '../../sovos-fixed-width-text';
import itemTypes from '../helpers/itemTypes';
import { getFocusStyles } from '../../internals/utils';
var getSelectedHoveredColor = function getSelectedHoveredColor(palette) {
  var selected = decomposeColor(palette.action.selected);
  var opacity = selected.values[3];
  if (opacity) {
    var newOpacity = opacity + palette.action.hoverOpacity;
    selected.values[3] = newOpacity < 1 ? newOpacity : 1;
    return recomposeColor(selected);
  }
  return emphasize(palette.action.selected, palette.action.hoverOpacity);
};
var ListItem = styled('li')({
  position: 'relative'
});
var ItemButton = styled(_ButtonBase, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'isExpandable';
  }
})(function (_ref) {
  var isExpandable = _ref.isExpandable,
    _ref$theme = _ref.theme,
    palette = _ref$theme.palette,
    spacing = _ref$theme.spacing,
    typography = _ref$theme.typography;
  return _objectSpread(_objectSpread({}, typography.body1), {}, {
    cursor: 'pointer',
    display: 'flex',
    margin: 0,
    minHeight: spacing(4.5),
    paddingBottom: 0,
    paddingLeft: isExpandable ? 0 : spacing(2),
    paddingRight: spacing(2),
    paddingTop: 0,
    textAlign: 'left',
    width: '100%',
    '&:hover, &:focus, &:focus-visible': {
      backgroundColor: palette.action.hover
    },
    '&:focus-visible, &.Mui-focusVisible': _objectSpread({
      backgroundColor: palette.action.hover
    }, getFocusStyles({
      offset: -2
    })),
    '&.sovosTreeListItem__ItemButton--selected': {
      backgroundColor: palette.action.selected,
      '&.Mui-focusVisible': {
        backgroundColor: getSelectedHoveredColor(palette)
      },
      '&:hover, &:focus, &:focus-visible': {
        backgroundColor: getSelectedHoveredColor(palette)
      }
    },
    '&.sovosTreeListItem__ItemButton--noHover': {
      '&:hover': {
        cursor: 'default',
        backgroundColor: 'transparent'
      }
    },
    '&.sovosTreeListItem__ItemButton--disabled': {
      color: palette.text.disabled
    }
  });
});
var ItemText = styled('span', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'isExpandable';
  }
})(function (_ref2) {
  var isExpandable = _ref2.isExpandable,
    spacing = _ref2.theme.spacing;
  return {
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,
    height: '100%',
    marginLeft: isExpandable ? spacing(5) : 0,
    minWidth: 0,
    padding: 0
  };
});
var NestedItems = styled('ul')(function (_ref3) {
  var spacing = _ref3.theme.spacing;
  return {
    listStyle: 'none',
    paddingLeft: spacing(4.5)
  };
});
var ToggleButton = styled(SovosIconButton)(function (_ref4) {
  var _ref4$theme = _ref4.theme,
    palette = _ref4$theme.palette,
    spacing = _ref4$theme.spacing;
  return {
    color: palette.text.primary,
    cursor: 'pointer',
    left: spacing(0.5),
    position: 'absolute',
    top: spacing(0.25),
    transition: 'transform 0.3s',
    '&[aria-expanded="true"]': {
      transform: 'rotate(90deg)'
    },
    zIndex: 4
  };
});
var Loading = styled('div')(function (_ref5) {
  var spacing = _ref5.theme.spacing;
  return {
    padding: spacing(4),
    textAlign: 'center',
    '& p': {
      marginTop: spacing()
    }
  };
});
var TreeListItem = function TreeListItem(_ref6) {
  var _SovosTypography, _clsx;
  var classes = _ref6.classes,
    expandedItems = _ref6.expandedItems,
    hasCheckbox = _ref6.hasCheckbox,
    isExpandable = _ref6.isExpandable,
    isTopLevel = _ref6.isTopLevel,
    item = _ref6.item,
    loadingMessage = _ref6.loadingMessage,
    onClick = _ref6.onClick,
    onExpand = _ref6.onExpand,
    parentId = _ref6.parentId,
    selectedItems = _ref6.selectedItems,
    showLessTooltipText = _ref6.showLessTooltipText,
    showMoreTooltipText = _ref6.showMoreTooltipText;
  var isDivider = item.type === itemTypes.HEADER || item.type === itemTypes.DIVIDER;
  var isDisabled = item.disabled === true;
  var parent = parentId ? "".concat(parentId, "_") : '';
  var id = "".concat(parent).concat(item.id);
  if (!isTopLevel && isDivider) {
    console.error('Headers and dividers are only allowed at the top level');
    return null;
  }
  var isExpanded = function isExpanded() {
    return expandedItems[id];
  };
  var renderToggle = function renderToggle(expanded) {
    if (!isExpandable) {
      return null;
    }
    function handleKeyUp(e) {
      if (e.key === 'ArrowRight' && !expanded) {
        onExpand(e, id, item);
      }
      if (e.key === 'ArrowLeft' && expanded) {
        onExpand(e, id, item);
      }
    }
    var labelText = expanded ? showLessTooltipText : showMoreTooltipText;
    if (item.nestedItems || item.nestedItemCount) {
      return /*#__PURE__*/React.createElement(ToggleButton, {
        "aria-expanded": expanded ? 'true' : 'false',
        className: classes === null || classes === void 0 ? void 0 : classes.toggleBtn,
        "data-testid": "sovosTreeListItem__toggle",
        onKeyUp: function onKeyUp(e) {
          return handleKeyUp(e);
        },
        onClick: function onClick(e) {
          return onExpand(e, id, item);
        },
        size: "small",
        tooltipText: labelText
      }, _ArrowRight || (_ArrowRight = /*#__PURE__*/React.createElement(ArrowRight, null)));
    }
    return null;
  };
  var renderNestedItems = function renderNestedItems() {
    var expanded = isExpanded();
    if (item.nestedItems && expanded) {
      return /*#__PURE__*/React.createElement(NestedItems, {
        className: classes === null || classes === void 0 ? void 0 : classes.nestedItem
      }, item.nestedItems.map(function (nItem) {
        return /*#__PURE__*/React.createElement(TreeListItem, {
          hasCheckbox: hasCheckbox,
          key: nItem.id,
          item: nItem,
          selectedItems: selectedItems,
          onClick: onClick,
          onExpand: onExpand,
          parentId: id,
          expandedItems: expandedItems,
          classes: classes,
          isExpandable: !!(nItem.nestedItems || nItem.nestedItemCount),
          loadingMessage: loadingMessage
        });
      }));
    }
    if (item.isLoading && expanded) {
      return /*#__PURE__*/React.createElement(Loading, {
        className: classes === null || classes === void 0 ? void 0 : classes.loading
      }, _LinearProgress || (_LinearProgress = /*#__PURE__*/React.createElement(_LinearProgress2, null)), _SovosTypography || (_SovosTypography = /*#__PURE__*/React.createElement(SovosTypography, {
        color: "text.secondary",
        variant: "body1"
      }, loadingMessage)));
    }
    return null;
  };
  var handleClick = isDisabled || item.isExpandOnly ? undefined : function () {
    return onClick(id, item);
  };
  var isSelected = selectedItems.includes(id);
  var noHover = isDisabled || !onClick;
  return /*#__PURE__*/React.createElement(ListItem, {
    className: clsx(classes === null || classes === void 0 ? void 0 : classes.listItem, 'sovosTreeListItem'),
    "data-testid": "sovosTreeListItem"
  }, isDivider ? /*#__PURE__*/React.createElement(SectionDivider, {
    content: item.content
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, renderToggle(isExpanded()), /*#__PURE__*/React.createElement(ItemButton, {
    className: clsx('sovosTreeListItem__ItemButton', (_clsx = {
      'sovosTreeListItem__ItemButton--selected': isSelected
    }, _defineProperty(_clsx, classes === null || classes === void 0 ? void 0 : classes.selectedItem, (classes === null || classes === void 0 ? void 0 : classes.selectedItem) && isSelected), _defineProperty(_clsx, 'sovosTreeListItem__ItemButton--noHover', noHover), _defineProperty(_clsx, classes === null || classes === void 0 ? void 0 : classes.noHover, (classes === null || classes === void 0 ? void 0 : classes.noHover) && noHover), _defineProperty(_clsx, 'sovosTreeListItem__ItemButton--disabled', isDisabled), _defineProperty(_clsx, classes === null || classes === void 0 ? void 0 : classes.disabledItem, (classes === null || classes === void 0 ? void 0 : classes.disabledItem) && isDisabled), _clsx)),
    classes: {
      root: classes === null || classes === void 0 ? void 0 : classes.item,
      focusVisible: classes === null || classes === void 0 ? void 0 : classes.itemFocusVisible
    },
    component: "button",
    disabled: isDisabled || !onClick,
    disableRipple: true,
    disableTouchRipple: true,
    isExpandable: isExpandable,
    onClick: handleClick
  }, /*#__PURE__*/React.createElement(ItemText, {
    className: clsx('sovosTreeListItem__text', classes === null || classes === void 0 ? void 0 : classes.itemText),
    isExpandable: isExpandable
  }, hasCheckbox && /*#__PURE__*/React.createElement(SovosCheckbox, {
    checked: isSelected,
    size: "small"
  }), typeof item.content === 'string' ? /*#__PURE__*/React.createElement(SovosFixedWidthText, {
    text: item.content,
    className: "sovosTreeListText"
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, item.content))), renderNestedItems()));
};
var treeListItemShape = {
  content: function content(props) {
    var content = props.content,
      type = props.type;
    if (type !== itemTypes.DIVIDER && !content) {
      return new Error('The prop `item.content` is required when type is not DIVIDER.');
    }
    return null;
  },
  disabled: bool,
  id: string.isRequired,
  isLoading: bool,
  nestedItemCount: number,
  selected: bool,
  type: oneOf(_toConsumableArray(Object.values(itemTypes)))
};
treeListItemShape.nestedItems = arrayOf(shape(treeListItemShape));
export var treeListItemPropTypes = shape(treeListItemShape);
TreeListItem.propTypes = {
  classes: object.isRequired,
  expandedItems: object.isRequired,
  hasCheckbox: bool.isRequired,
  isExpandable: bool.isRequired,
  isTopLevel: bool,
  item: treeListItemPropTypes.isRequired,
  loadingMessage: string,
  onClick: func,
  onExpand: func.isRequired,
  parentId: string,
  selectedItems: array.isRequired,
  showLessTooltipText: string,
  showMoreTooltipText: string
};
TreeListItem.defaultProps = {
  isTopLevel: false,
  loadingMessage: 'Loading Items...',
  onClick: undefined,
  parentId: '',
  showLessTooltipText: 'Show Less',
  showMoreTooltipText: 'Show More'
};
export default TreeListItem;